// External packages
import * as React from 'react';

// Utils
import { twMerge } from 'tailwind-merge';

export const Card: React.FC<React.ComponentPropsWithoutRef<'div'>> = ({
  className,
  ...props
}) => (
  <div
    {...props}
    className={twMerge(
      'rounded-lg border border-gray-200 bg-gray-50 p-6',
      className
    )}
  />
);
